import { Base } from "../core/base.model";
import { Tickets } from "./tickets.model";
import { Empleado } from "src/app/shared/model/empleado/empleado.model";

export class TicketCapacitacion extends Base {
  id_ticket_cap: number;
  ticket: Tickets;
  nombreCurso: string;
  temaRequerido: string;
  objetivoCurso: string;
  nivelCurso: string;
  fechaReqCap: string;
  observaciones: string;
  nombreProyecto: string;
  personalCap: Empleado[];
}
